import { render, staticRenderFns } from "./UserWizard.vue?vue&type=template&id=511a38a9"
import script from "./UserWizard.vue?vue&type=script&lang=js"
export * from "./UserWizard.vue?vue&type=script&lang=js"
import style0 from "./UserWizard.vue?vue&type=style&index=0&id=511a38a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports